export default {
  computed: {
    basePasswordRules() {
      return [
        {
          required: true,
          message: this.$t('VALIDATION_REQUIRED_ERR'),
          trigger: 'blur',
        },
        {
          type: 'string',
          pattern: /(?=.*\d)(?=.*[A-Z]).{8,}$/,
          message: this.$t('PASSWORD_VALIDATION_ERR'),
          trigger: 'blur',
        },
      ];
    },
  },
  methods: {
    checkPasswordConfirm(formModelName) {
      return (rule, value, cb) => {
        const { password, checkPass } = this[formModelName];
        if (password !== checkPass) {
          cb(new Error(this.$t('INVALID_INPUT_VALUE_CHECK_PASS')));
        }
        cb();
      };
    },
  },
};
